import type { LevelConfig } from "../level_config.js";
import { PlayDialogDifficulty } from "../ui/dialog/play_dialog.js";

export interface EscalatorConfig
{
  gapCubes?: number;
  levels?: number[];
}

export class ConveyorMode
{
  public static readonly LEVEL = 0;
  public static readonly ESCALATOR: EscalatorConfig = { gapCubes: 1 };

  private static readonly BELT_COLS = 9;

  public static readonly BELT: LevelConfig = {
    level: ConveyorMode.LEVEL,
    difficulty: PlayDialogDifficulty.Common,
    layers: [ { grid: [ new Array( ConveyorMode.BELT_COLS ).fill( 0 ) ], pieces: [] } ],
  };
}
